import { useId } from 'react';

export interface OpcionSeleccionable {
  valor: number;
  titulo: string;
  descripcion: string;

  destacada?: boolean;
}

interface Props {
  opciones: OpcionSeleccionable[];
  valor: number | null;
  alElegir: (valor: number) => void;
  nombre: string;
  vacio?: string;
}

export function ListaSeleccionable({ opciones, valor, alElegir, nombre, vacio }: Props) {
  const id = useId();

  if (opciones.length === 0) {
    return (
      <p className="rounded-lg border border-dashed border-armazon-200 px-3 py-6 text-center text-sm text-armazon-500">
        {vacio ?? 'No hay opciones disponibles'}
      </p>
    );
  }

  return (
    <div role="radiogroup" aria-label={nombre} className="grid gap-2">
      {opciones.map((o) => {
        const elegida = valor === o.valor;
        const idOpcion = `${id}-${o.valor}`;

        return (
          <label
            key={o.valor}
            htmlFor={idOpcion}
            className={[
              'flex cursor-pointer items-center gap-3 rounded-lg border px-4 py-3 transition-colors',
              elegida
                ? 'border-marca-500 bg-marca-50 ring-1 ring-marca-500'
                : 'border-armazon-200 bg-white hover:bg-armazon-50',
            ].join(' ')}
          >
            <input
              type="radio"
              id={idOpcion}
              name={nombre}
              checked={elegida}
              onChange={() => alElegir(o.valor)}
              className="size-4 shrink-0 accent-marca-600"
            />

            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-semibold text-armazon-900">
                {o.titulo}
              </span>
              <span className="block truncate text-xs text-armazon-500">{o.descripcion}</span>
            </span>

            {o.destacada && (
              <span className="shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-700 ring-1 ring-amber-200">
                sistema
              </span>
            )}
          </label>
        );
      })}
    </div>
  );
}
